module.exports = __webpack_public_path__ + "static/media/image10.67392c48.JPG";